import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _Bank;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import * as immutable from 'immutable';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import partial from 'lodash/partial';
import { IconMoreSolid, IconPlusLine } from '@instructure/ui-icons';
import { BreadcrumbLink } from '@instructure/ui-breadcrumb';
import { Button } from '@instructure/ui-buttons';
import { Heading } from '@instructure/ui-heading';
import { AccessibleContent } from '@instructure/ui-a11y-content';
import { jsx } from '@instructure/emotion';
import { Checkbox } from '@instructure/ui-checkbox';
import { View } from '@instructure/ui-view';
import { HeaderBreadCrumb } from '../HeaderBreadCrumb';
import BankRecord from '../../../common/records/Bank';
import Page from '../../../common/components/layout/Page';
import PaginatedCollection from '../../../common/components/shared/PaginatedCollection';
import QuizEntry from '../../../common/records/QuizEntry';
import t from '@instructure/quiz-i18n/es/format-message';
import debounceLatestPromise from '../../../common/util/debounceLatestPromise';
import AddBankEntryModal from '../../../banks/components/AddBankEntryModal';
import BankEntriesList from '../../../banks/components/BankEntriesList';
import BankSearch from '../../../banks/components/BankSearch';
import HeaderMenu from '../../../banks/components/HeaderMenu';
import NavWrapper from '../NavWrapper';
import { ADD_BANK_ENTRY_MODAL, BANKS_BANK_ENTRY_PAGINATION, CAN_EDIT, REMOVED_ACCESS, READ_ONLY, withStyleOverrides } from '@instructure/quiz-common';
import generateStyle from './styles';
import generateComponentTheme from './theme';
export var Bank = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_Bank = /*#__PURE__*/function (_Component) {
  function Bank() {
    var _this;
    _classCallCheck(this, Bank);
    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Bank, [].concat(_args));
    _defineProperty(_this, "state", {
      sharedWithCourse: false,
      shareWithCourseCheckboxDisabled: true
    });
    _defineProperty(_this, "openAddBankEntryModal", function () {
      _this.props.openModal(ADD_BANK_ENTRY_MODAL, {
        modalTrigger: _this.createBankEntryButton
      });
    });
    _defineProperty(_this, "renderHeaderMenu", function () {
      if (!_this.props.isCompact) {
        return jsx(HeaderMenu, {
          bank: _this.props.bank,
          iceTopNavBarEnabled: _this.props.iceTopNavBarEnabled,
          id: "BankMenu",
          renderIcon: jsx(IconMoreSolid, null)
        });
      }
    });
    _defineProperty(_this, "storeCreateBankEntryButtonRef", function (c) {
      _this.createBankEntryButton = c;
    });
    _defineProperty(_this, "renderBankBreadCrumbLink", function () {
      return jsx(BreadcrumbLink, {
        key: "bank"
      }, _this.props.bank.title);
    });
    _defineProperty(_this, "toggleCheckbox", function () {
      // disable until request resolves
      _this.setState({
        shareWithCourseCheckboxDisabled: true
      });
      _this.changeSharedPermissions();
    });
    _defineProperty(_this, "unshareBankWithCourse", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(sharedBank) {
        var _this$props, updateSharedBankPermission, bankId, getSharedBank, scope;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, updateSharedBankPermission = _this$props.updateSharedBankPermission, bankId = _this$props.bankId, getSharedBank = _this$props.getSharedBank, scope = _this$props.scope;
              _context.next = 3;
              return updateSharedBankPermission(bankId, sharedBank.get('id'), REMOVED_ACCESS);
            case 3:
              getSharedBank(bankId, scope.type, scope.uuid)["catch"](function (err) {
                // make sure the user still has access to the bank
                if (err.response.status === 401) {
                  _this.props.navigateToBanks();
                }
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "translatedPermissionLevel", function (permission) {
      return _defineProperty(_defineProperty({}, CAN_EDIT, t('edit')), READ_ONLY, t('view'))[permission];
    });
    _defineProperty(_this, "confirmUnshareBankWithCourse", function () {
      var confirmText = t('You are about to remove { accessLevel } access for { entityTitle } to this bank.', {
        accessLevel: _this.translatedPermissionLevel(_this.props.courseSharedBank.get('permission')),
        entityTitle: _this.props.scope.title
      });
      _this.props.withConfirm(partial(_this.unshareBankWithCourse, _this.props.courseSharedBank), {
        title: t('Unshare Bank with Course'),
        text: confirmText,
        continueText: t('Confirm'),
        onCancel: _this.onCancelUnshareBankWithCourse
      });
    });
    _defineProperty(_this, "onCancelUnshareBankWithCourse", function () {
      _this.setState({
        shareWithCourseCheckboxDisabled: false
      });
    });
    _defineProperty(_this, "addBankToQuiz", function () {
      var newEntry = QuizEntry.create({
        entryId: _this.props.bankId,
        entryType: 'Bank',
        position: _this.props.position,
        stimulusQuizEntryId: _this.props.stimulusId
      });
      _this.props.addEntryToQuiz(_this.props.activeQuizId, newEntry.entryId, newEntry.entryType, newEntry.getProperties(), false).then(function () {
        _this.props.screenreaderNotification(t('Bank was successfully added to the quiz'));
      });
    });
    _defineProperty(_this, "renderTopLeftMenu", function () {
      return jsx("div", {
        css: _this.props.styles.topLeftMenu
      }, _this.renderMultiAdd());
    });
    _defineProperty(_this, "renderTopRightMenu", function () {
      return jsx("div", {
        css: _this.props.styles.topRightMenu
      }, _this.renderNewBankEntryButton());
    });
    _defineProperty(_this, "announceResults", function (_ref2) {
      var totalPages = _ref2.totalPages;
      var message = t("{\n      count, plural,\n         =0 {No search results found}\n        one {Displaying one page of results}\n      other {Displaying # pages of results}\n    }", {
        count: totalPages
      });
      // Audibly announce when search results are ready.
      // We debounce using a larger interval for a11y, so that the user isn't
      // flooded with "Search results ready" messages every time they type a
      // character
      _this.props.screenreaderNotification(message);
    });
    _defineProperty(_this, "debouncedAnnounceResults", debounce(_this.announceResults, 1000));
    _defineProperty(_this, "getPage", function (page, search) {
      var _this$props2 = _this.props,
        getBankEntries = _this$props2.getBankEntries,
        bankId = _this$props2.bankId,
        useBankSearch = _this$props2.useBankSearch;
      var text = search.get('text');
      var interactionTypes = search.get('interactionTypes', immutable.Set()).toJS();
      var tagIds = search.get('tags', []).map(function (tag) {
        return tag.id;
      });
      var filters = {
        interactionTypes: interactionTypes,
        tags: tagIds
      };
      var params = {
        page: page,
        text: text,
        filters: filters
      };
      var resultPage = getBankEntries(bankId, useBankSearch, params);
      if (resultPage) {
        return resultPage.then(function (results) {
          _this.debouncedAnnounceResults(results);
          return results;
        });
      } else {
        return Promise.resolve(null);
      }
    });
    _defineProperty(_this, "getPageDebounced", debounceLatestPromise(function () {
      var _this2;
      return (_this2 = _this).getPage.apply(_this2, arguments);
    }, 100));
    _defineProperty(_this, "renderRecords", function (recordIds) {
      var addEntryFunc = _this.props.isCompact && _this.props.addEntryToQuiz || null;
      return jsx(BankEntriesList, {
        addEntryToQuiz: addEntryFunc,
        bank: _this.props.bank,
        navigateToBankEntry: _this.props.navigateToBankEntry,
        recordIds: recordIds,
        isQuizContentLocked: _this.props.isQuizContentLocked
      });
    });
    return _this;
  }
  _inherits(Bank, _Component);
  return _createClass(Bank, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.resetSearch(this.props.bankId);
      if (this.props.onError) {
        this.props.getBank(this.props.bankId)["catch"](this.props.onError);
        if (this.shouldRenderShareWithCourseCheckbox()) {
          this.props.getSharedBank(this.props.bankId, this.props.scope.type, this.props.scope.uuid)["catch"](this.props.onError);
        }
      } else {
        this.props.getBank(this.props.bankId);
        if (this.shouldRenderShareWithCourseCheckbox()) {
          this.props.getSharedBank(this.props.bankId, this.props.scope.type, this.props.scope.uuid);
        }
      }

      // when courseSharedBank is already loaded
      if (this.props.courseSharedBank) {
        this.setShareWithCourseCheckbox();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _prevProps$courseShar, _this$props$courseSha;
      var permissionChanged = ((_prevProps$courseShar = prevProps.courseSharedBank) === null || _prevProps$courseShar === void 0 ? void 0 : _prevProps$courseShar.get('permission')) !== ((_this$props$courseSha = this.props.courseSharedBank) === null || _this$props$courseSha === void 0 ? void 0 : _this$props$courseSha.get('permission'));
      if (this.props.courseSharedBank && permissionChanged) {
        this.setShareWithCourseCheckbox();
      }
    }
  }, {
    key: "setShareWithCourseCheckbox",
    value: function setShareWithCourseCheckbox() {
      if (this.props.courseSharedBank.get('permission') === REMOVED_ACCESS) {
        this.setState({
          sharedWithCourse: false,
          shareWithCourseCheckboxDisabled: false
        });
      } else {
        this.setState({
          sharedWithCourse: true,
          shareWithCourseCheckboxDisabled: false
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.removeSharedBank(this.placeholderCourseSharedBankKey());
    }
  }, {
    key: "placeholderCourseSharedBankKey",
    value: function placeholderCourseSharedBankKey() {
      return "notshared_".concat(this.props.bankId, "_").concat(this.props.scope.uuid);
    }
  }, {
    key: "renderNav",
    value: function renderNav() {
      var _this$props3 = this.props,
        scope = _this$props3.scope,
        closeTray = _this$props3.closeTray,
        navigateToBanks = _this$props3.navigateToBanks,
        navigateToBuild = _this$props3.navigateToBuild,
        returnToUrl = _this$props3.returnToUrl;
      var isScopeEmpty = !Object.keys(scope).length;
      return jsx(NavWrapper, {
        closeTray: closeTray,
        navigateToBanks: navigateToBanks,
        navigateToBuild: navigateToBuild,
        renderHeaderMenu: this.renderHeaderMenu,
        returnToUrl: isScopeEmpty ? null : returnToUrl,
        scope: scope,
        isCompact: this.props.isCompact,
        iceTopNavBarEnabled: this.props.iceTopNavBarEnabled,
        menuItemPath: "/banks/".concat(this.props.bankId)
      }, this.renderBankBreadCrumbLink());
    }
  }, {
    key: "renderName",
    value: function renderName() {
      return jsx("div", {
        css: this.props.styles.bankName
      }, jsx(Heading, {
        level: "h1"
      }, this.props.bank.title || t('Bank')));
    }
  }, {
    key: "renderAddBankEntryModal",
    value: function renderAddBankEntryModal() {
      if (!this.props.isCompact) {
        return jsx(AddBankEntryModal, {
          bankId: this.props.bankId,
          navigateToBankEntry: this.props.navigateToBankEntry
        });
      }
    }
  }, {
    key: "changeSharedPermissions",
    value: function changeSharedPermissions() {
      if (this.props.bank.canEdit()) {
        if (!this.state.sharedWithCourse) {
          var shareBank = {
            entityId: this.props.scope.uuid,
            entityType: this.props.scope.type,
            title: this.props.scope.title,
            permission: READ_ONLY,
            bankId: this.props.bankId
          };
          this.props.removeSharedBank(this.placeholderCourseSharedBankKey());
          this.props.shareBank(shareBank);
        } else {
          this.confirmUnshareBankWithCourse();
        }
      }
    }
  }, {
    key: "shouldRenderShareWithCourseCheckbox",
    value: function shouldRenderShareWithCourseCheckbox() {
      return this.props.showShareBankFromTray && this.props.scope.type === 'course' && this.props.scope.title && this.props.scope.uuid;
    }
  }, {
    key: "renderCheckbox",
    value: function renderCheckbox() {
      if (!this.shouldRenderShareWithCourseCheckbox()) {
        return null;
      }
      var label = t('Share with { courseName }', {
        courseName: this.props.scope.title
      });
      return jsx(View, {
        margin: "small 0",
        as: "div"
      }, jsx(Checkbox, {
        checked: this.state.sharedWithCourse,
        label: label,
        onChange: this.toggleCheckbox,
        disabled: this.props.bank.canEdit() ? this.state.shareWithCourseCheckboxDisabled : true,
        "data-automation": "sdk-share-bank-with-course-checkbox"
      }));
    }
  }, {
    key: "renderModals",
    value: function renderModals() {
      return jsx("div", null, this.renderAddBankEntryModal());
    }
  }, {
    key: "renderNewBankEntryButton",
    value: function renderNewBankEntryButton() {
      if (!this.props.isCompact && this.props.bank.canEdit()) {
        return jsx(Button, {
          margin: "small none",
          ref: this.storeCreateBankEntryButtonRef,
          color: "primary",
          onClick: this.openAddBankEntryModal,
          "data-automation": "sdk-new-bank-entry-button",
          renderIcon: IconPlusLine
        }, jsx(AccessibleContent, {
          alt: t('Create Bank Entry')
        }, t('New')));
      }
    }
  }, {
    key: "renderMultiAdd",
    value: function renderMultiAdd() {
      var isEmpty = this.props.bank.itemEntryCount === 0;
      if (this.props.isCompact && !this.props.isQuizContentLocked && !isEmpty) {
        return jsx(Button, {
          onClick: this.addBankToQuiz,
          margin: "small none",
          renderIcon: IconPlusLine,
          "data-automation": "sdk-add-bank-to-quiz-button"
        }, jsx(AccessibleContent, {
          alt: t('Add this bank to quiz')
        }, t('All / Random')));
      }
    }
  }, {
    key: "stateKey",
    value: function stateKey() {
      return "".concat(BANKS_BANK_ENTRY_PAGINATION, ":").concat(this.props.bankId);
    }
  }, {
    key: "renderSearch",
    value: function renderSearch() {
      if (this.props.bank.filters !== null && this.props.useBankSearch) {
        var its = this.props.bank.filters.interaction_types;
        var tags = this.props.bank.filters.tags;
        return jsx(BankSearch, {
          interactionTypes: its,
          tags: tags,
          pageStateKey: this.stateKey(),
          showFilters: false
        });
      }
    }
  }, {
    key: "emptyLoadText",
    value: function emptyLoadText() {
      var noFilters = this.props.bank.filters === null;
      var noQuestions = function noQuestions() {
        return t('There are no questions in this bank yet.');
      };
      var noResults = function noResults() {
        return t('The search returned no results.');
      };
      return noFilters ? noQuestions() : noResults();
    }
  }, {
    key: "render",
    value: function render() {
      return jsx(Page, null, this.renderModals(), this.renderNav(), jsx("div", {
        css: this.props.styles.content
      }, this.props.iceTopNavBarEnabled && jsx("div", {
        css: this.props.styles.breadcrumb
      }, jsx(HeaderBreadCrumb, {
        returnToUrl: this.props.returnToUrl,
        scope: this.props.scope,
        navigateToBanks: this.props.navigateToBanks,
        navigateToBuild: this.props.navigateToBuild
      }, this.renderBankBreadCrumbLink())), this.renderName(), this.renderCheckbox(), jsx("div", {
        css: this.props.styles.topMenu
      }, this.renderTopLeftMenu(), this.renderTopRightMenu()), this.renderSearch(), jsx(PaginatedCollection, {
        empty: this.emptyLoadText(),
        params: this.props.search,
        getPage: this.getPageDebounced,
        renderRecords: this.renderRecords,
        stateKey: this.stateKey()
      })));
    }
  }]);
}(Component), _defineProperty(_Bank, "displayName", 'Bank'), _defineProperty(_Bank, "componentId", "Quizzes".concat(_Bank.displayName)), _defineProperty(_Bank, "propTypes", {
  activeQuizId: PropTypes.string,
  addEntryToQuiz: PropTypes.func,
  bankId: PropTypes.string.isRequired,
  bank: PropTypes.instanceOf(BankRecord).isRequired,
  useBankSearch: PropTypes.bool,
  closeTray: PropTypes.func,
  getBank: PropTypes.func.isRequired,
  getBankEntries: PropTypes.func.isRequired,
  getSharedBank: PropTypes.func.isRequired,
  isCompact: PropTypes.bool,
  isQuizContentLocked: PropTypes.bool.isRequired,
  navigateToBanks: PropTypes.func.isRequired,
  // can be from consumer
  navigateToBankEntry: PropTypes.func.isRequired,
  // can be from consumer
  navigateToBuild: PropTypes.func,
  // from consumer
  scope: PropTypes.shape({
    type: PropTypes.string,
    uuid: PropTypes.string,
    title: PropTypes.string,
    launch_context_uuid: PropTypes.string,
    root_account_name: PropTypes.string
  }),
  courseSharedBank: ImmutablePropTypes.map,
  returnToUrl: PropTypes.string,
  // from consumer
  onError: PropTypes.func,
  openModal: PropTypes.func.isRequired,
  position: PropTypes.number,
  removeSharedBank: PropTypes.func.isRequired,
  resetSearch: PropTypes.func.isRequired,
  screenreaderNotification: PropTypes.func.isRequired,
  search: ImmutablePropTypes.map.isRequired,
  shareBank: PropTypes.func.isRequired,
  stimulusId: PropTypes.string,
  showShareBankFromTray: PropTypes.bool,
  updateSharedBankPermission: PropTypes.func.isRequired,
  withConfirm: PropTypes.func.isRequired,
  iceTopNavBarEnabled: PropTypes.bool,
  styles: PropTypes.object
}), _defineProperty(_Bank, "defaultProps", {
  activeQuizId: null,
  addEntryToQuiz: null,
  closeTray: function closeTray() {},
  useBankSearch: false,
  isCompact: false,
  minSearchRefreshInterval: 100,
  navigateToBuild: null,
  onError: null,
  position: 0,
  stimulusId: null,
  scope: {},
  returnToUrl: null,
  isQuizContentLocked: false,
  showShareBankFromTray: false,
  courseSharedBank: null,
  iceTopNavBarEnabled: false
}), _Bank)) || _class);
export default Bank;